// extracted by mini-css-extract-plugin
export var avatarContainer = "_gb-0";
export var avatarTypingWave = "_gb-i";
export var gray = "_gb-f";
export var green = "_gb-c";
export var icon = "_gb-9";
export var image = "_gb-1";
export var lg = "_gb-6";
export var md = "_gb-5";
export var presenceDot = "_gb-b";
export var red = "_gb-d";
export var sm = "_gb-4";
export var status = "_gb-a";
export var typingDot = "_gb-h";
export var typingPill = "_gb-g";
export var xl = "_gb-7";
export var xs = "_gb-3";
export var xxl = "_gb-8";
export var xxs = "_gb-2";
export var yellow = "_gb-e";